function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTelevision = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.149,
    y: 0.61,
    width: 44,
    height: 44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.749,11.81L7.749,28.01L36.549,28.01L36.549,11.81L7.749,11.81ZM4.149,11.81C4.149,9.825 5.763,8.21 7.749,8.21L36.549,8.21C38.534,8.21 40.149,9.825 40.149,11.81L40.149,28.01C40.149,29.996 38.534,31.61 36.549,31.61L7.749,31.61C5.763,31.61 4.149,29.996 4.149,28.01L4.149,11.81ZM11.349,33.41L32.949,33.41C33.944,33.41 34.749,34.215 34.749,35.21C34.749,36.206 33.944,37.01 32.949,37.01L11.349,37.01C10.353,37.01 9.549,36.206 9.549,35.21C9.549,34.215 10.353,33.41 11.349,33.41Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTelevision);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/television.60d50e5e80334ef1f37d494313851d86.svg";